export default __webpack_public_path__ + "static/media/distribution.c00bf167.webp";